<template lang="pug">
  div.registration-page
    registration-form
</template>

<script>
import registrationForm from '../components/registration/registration-form.vue'
export default {
  components: {
    registrationForm
  }
}
</script>

<style lang="scss" scoped>
  .registration-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
</style>
